/**
 * Constant for empty ID values used throughout the application
 * This centralizes the empty ID representation to ensure consistency
 */
export const EMPTY_ID = '';

export const isEmptyId = (id?: string | null): boolean => !id || id === '0';
